import type { FormDto } from "../../types/form";
import type { FormListItemDto } from "../../types/formList";

export type FormSource = "native" | "yandex";

export type FormWithSource = {
  source?: FormSource | string | null;
};

export function normalizeFormSource(
  value: FormSource | string | null | undefined,
): FormSource {
  return value === "yandex" ? "yandex" : "native";
}

export function getFormSource(form: FormWithSource): FormSource {
  return normalizeFormSource(form.source);
}

export function isYandexForm(form: FormWithSource): boolean {
  return getFormSource(form) === "yandex";
}

export function isNativeForm(form: FormWithSource): boolean {
  return !isYandexForm(form);
}

export function isGlobalManager(roles: string[]): boolean {
  return roles.some((role) => ["admin", "moderator", "manager"].includes(role));
}

export function formListAnswersCount(
  form: FormListItemDto,
): number | undefined {
  const raw =
    form.answersCount ?? (form as { answers_count?: number }).answers_count;
  return typeof raw === "number" && Number.isFinite(raw) ? raw : undefined;
}

export function formEditorUrl(form: FormDto | FormListItemDto): string | null {
  const url = form.editorUrl ?? (form as { editor_url?: string }).editor_url;
  return typeof url === "string" && url.trim() ? url.trim() : null;
}

export function formPublicYandexUrl(
  form: FormDto | FormListItemDto,
): string | null {
  const url = form.publicUrl ?? (form as { public_url?: string }).public_url;
  return typeof url === "string" && url.trim() ? url.trim() : null;
}
